/* eslint-disable no-undef */
import { render } from 'react-dom';
import ReactDOM from 'react-dom/client';
import Component from './main'; // eslint-disable-line

if (module.hot) {
  module.hot.accept();
}

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(<Component />);
